// extracted by mini-css-extract-plugin
export default {"title":"BigColumn_title__9Ntp5","subtitle":"BigColumn_subtitle__GNszS"};